<template>
	<div class="reported_issues">
		<button v-if="image.is_reported" class="btn btn-info btn-block" @click="validate" :disabled="hasOpenSuggestions">{{ __('translations.button.validate') }}</button>
		<div v-if="isValidated && !hasOpenSuggestions" class="alert alert-success">
			{{ __('translations.message.validated') }}
		</div>
		<hr class="mb-0" />
		<div v-for="suggestion in image.suggestions" :key="'suggestion-' + suggestion.id" class="card border-secondary mb-3">
			<div class="card-header py-2">
		    	<small v-if="suggestion.accepted_by !== null" class="float-left text-muted">Accepté par {{suggestion.accepted_user.name}} le {{formatDate(suggestion.accepted_at)}}</small>
		    	<small v-else-if="suggestion.rejected_by !== null" class="float-left text-muted">Rejeté par {{suggestion.rejected_user.name}} le {{formatDate(suggestion.rejected_at)}}</small>
		    	<small class="float-right text-muted">Soumis le {{formatDate(suggestion.created_at)}}</small>
		    </div>
	    	<div class="card-body py-3">
		    	<div v-if="suggestion.suggested_title !== null" class="form-group">
					<label for="suggested_title" class="col-12 col-form-label col-form-label-sm px-0">{{ __('translations.label.suggested_title') }}</label>
					<input readonly type="text" class="form-control form-control-sm" :value="suggestion.suggested_title" />
				</div>
				<div v-if="suggestion.suggested_date !== null" class="form-group">
					<label for="suggested_date" class="col-12 col-form-label col-form-label-sm px-0">{{ __('translations.label.suggested_date') }}</label>
					<input readonly type="text" class="form-control form-control-sm" :value="formatDate(suggestion.suggested_date)" />
				</div>
				<div v-if="suggestion.suggested_tags.length > 0" class="form-group row">
					<label for="entitled" class="col-sm-12 col-form-label col-form-label-sm">{{ __('translations.label.suggested_tags') }}</label>
					<template v-for="tag in suggestion.suggested_tags">
						<div v-if="tag.action === 'new'" class="col-sm-12"><div class="badge badge-tag d-block new" style="white-space: break-spaces;">{{tag.label}}</div></div>
						<div v-else-if="tag.action === 'delete'" class="col-sm-12"><div class="badge badge-tag d-block deleted" style="white-space: break-spaces;">{{tag.label}}</div></div>
						<template v-else-if="tag.action === 'replace'">
							<div class="col-sm-6 pr-1"><div class="badge badge-tag d-block deleted" style="white-space: break-spaces;">{{tag.label}}</div></div>
							<div class="col-sm-6 pl-1"><div class="badge badge-tag d-block replace" style="white-space: break-spaces;">{{tag.newTag.label}}</div></div>
						</template>
					</template>
				</div>
				<div v-if="suggestion.comment" class="form-group">
					<label for="comment" class="col-sm-12 col-form-label col-form-label-sm px-0">{{ __('translations.label.issue_detail') }}</label>
					<textarea readonly class="form-control form-control-sm" :value="suggestion.comment" rows="3" style="resize: none;"></textarea>
				</div>
			</div>
			<div v-if="suggestion.accepted_by === null && suggestion.rejected_by === null" class="card-footer d-flex justify-content-between" style="line-height: 0.9rem;">
			    <button class="btn btn-success btn-sm" @click="accept(suggestion)" style="width: 32px" data-toggle="tooltip" :title="__('translations.tooltip.accept')"><i class="fas fa-check fa-lg i-button align-middle"></i></button>
				<button class="btn btn-danger btn-sm" @click="reject(suggestion)" style="width: 32px" data-toggle="tooltip" :title="__('translations.tooltip.reject')"><i class="fas fa-times fa-lg i-button align-middle"></i></button>
		    </div>
		</div>
	</div>
</template>

<script>
import {mapGetters} from 'vuex'
var moment = require('moment');

export default {
	name: 'ReportedIssues',
	data() {
		return {
			isValidated: false,
		}
	},
	computed: {
		...mapGetters([
			'image'
		]),
		hasOpenSuggestions() {
			var result = false;
			
			this.image.suggestions.map(suggestion => {
				if((suggestion.accepted_by === null || suggestion.accepted_by === '') &&
				(suggestion.rejected_by === null || suggestion.rejected_by === '')) {
					result = true;
				}
			})
			
			return result;
		}
	},
	methods: {
		formatDate(date) {
			return moment(date).format('DD.MM.YYYY');
		},
		accept(suggestion) {
			axios.get('/image/accept/suggestion/' + suggestion.id).then(response => {
				this.$store.commit('SET_IMAGE', response.data.image);
				Object.assign(suggestion, response.data.suggestion);
			});
		},
		reject(suggestion) {
			axios.get('/image/reject/suggestion/' + suggestion.id).then(response => {
				Object.assign(suggestion, response.data.suggestion);
			});
		},
		validate() {
			axios.get('/image/unreport/' + this.image.id).then(response => {
				this.isValidated = true;
				this.$emit('unreported');
								
				// Remove the image from the list of reported images on the home screen.
				this.$store.commit('SET_IMAGES', response.data);
			});
		}
	}
}
</script>